import { render, staticRenderFns } from "./RosetteCard.vue?vue&type=template&id=2b344d44&scoped=true&"
import script from "./RosetteCard.vue?vue&type=script&lang=js&"
export * from "./RosetteCard.vue?vue&type=script&lang=js&"
import style0 from "./RosetteCard.vue?vue&type=style&index=0&id=2b344d44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b344d44",
  null
  
)

export default component.exports